import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, Transition as _Transition, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f4c975"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative" }
const _hoisted_2 = ["id", "data-testid", "disabled", "data-disabled-reason", "onClick", "onMouseenter", "onFocus"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "tw-flex tw-w-full tw-flex-col" }
const _hoisted_5 = {
  key: 0,
  class: "tw-p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioButton = _resolveComponent("StudioButton")!
  const _component_StudioTooltip = _resolveComponent("StudioTooltip")!
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSlotEnabled)
      ? (_openBlock(), _createBlock(_component_StudioButton, {
          key: 0,
          ref: "studioDropdownTriggerButton",
          trackingId: "studio-dropdown-trigger-button",
          variant: _ctx.variant,
          dropdown: true,
          class: _normalizeClass(_ctx.extraTriggerButtonClasses),
          onClick: _ctx.toggleDropdownMenu
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.menuItems[_ctx.selectedItemIndex].title), 1)
          ]),
          _: 1
        }, 8, ["variant", "class", "onClick"]))
      : _renderSlot(_ctx.$slots, "triggerButton", {
          key: 1,
          setRef: _ctx.setSlotRef,
          toggleDropdownMenu: _ctx.toggleDropdownMenu
        }, undefined, true),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.isDropdownOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "dropdownContainer",
              "data-testid": "studio-dropdown-menu-list",
              class: _normalizeClass({
          'tw-z-50 tw-mt-1': true,
          'tw-absolute': !_ctx.useFixedPosition,
          'tw-bottom-10 tw-left-0': !_ctx.useFixedPosition && _ctx.position === 'top-right',
          'tw-bottom-10 tw-right-0': !_ctx.useFixedPosition && _ctx.position === 'top-left',
          'tw-left-0': !_ctx.useFixedPosition && (_ctx.position === 'right' || _ctx.position === 'bottom-right'),
          'tw-right-0': !_ctx.useFixedPosition && (_ctx.position === 'left' || _ctx.position === 'bottom-left'),
          'tw-min-w-[8rem]': _ctx.dropdownSize === 'small',
          'tw-w-64': _ctx.dropdownSize === 'default',
          'tw-fixed': _ctx.useFixedPosition,
          [_ctx.extraDropdownClasses]: _ctx.extraDropdownClasses
        })
            }, [
              _createElementVNode("div", {
                class: _normalizeClass({
            'tw-max-h-[400px] tw-overflow-auto tw-rounded-lg tw-border tw-bg-white tw-text-xs tw-font-medium tw-shadow-lg dark:tw-bg-black': true,
            [_ctx.dropdownMaxHeight]: _ctx.dropdownMaxHeight
          })
              }, [
                _renderSlot(_ctx.$slots, "dropdownHeader", {}, undefined, true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems.filter(item => !item.hidden), (menuItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: menuItem.id,
                    class: "tw-relative"
                  }, [
                    _createElementVNode("button", {
                      id: `item-${menuItem.id}`,
                      "data-testid": `menu-item-${menuItem.title}`,
                      disabled: menuItem.disabled,
                      "data-disabled-reason": menuItem.disabled && menuItem.disabledReason ? menuItem.disabledReason : undefined,
                      class: _normalizeClass({
                'tw-group/menu-item tw-flex tw-w-full tw-items-center tw-gap-1': true,
                'tw-text-left tw-transition-colors': true,
                'hover:tw-bg-deep-orange-600 hover:tw-text-white': !menuItem.isHeader,
                'tw-bg-deep-orange-50 tw-text-deep-orange-600 dark:tw-border-slate-800 dark:tw-text-white':
                  !menuItem.isHeader && _ctx.isItemSelected(menuItem) && _ctx.showSelectedState,
                'tw-gap-1 tw-px-3 tw-py-3': _ctx.dropdownSize === 'default',
                'tw-gap-1 tw-px-2 tw-py-2': _ctx.dropdownSize === 'matchTrigger',
                'tw-px-2 tw-py-2': _ctx.dropdownSize === 'small',
                'tw-cursor-not-allowed tw-opacity-50': menuItem.disabled,
                '-tw-mb-1 tw-mt-2 tw-cursor-default tw-font-normal tw-text-gray-400': menuItem.isHeader,
                [menuItem.extraClasses || '']: menuItem.extraClasses
              }),
                      onClick: ($event: any) => (menuItem.isHeader ? null : _ctx.selectMenuItem($event, menuItem.id)),
                      onMouseenter: ($event: any) => (_ctx.setHoveredItem(menuItem.id)),
                      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setHoveredItem(null))),
                      onFocus: ($event: any) => (_ctx.setHoveredItem(menuItem.id)),
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setHoveredItem(null)))
                    }, [
                      (menuItem.icon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(menuItem.icon), { class: "tw-h-4 tw-w-4" }))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", {
                          class: _normalizeClass({
                    'tw-break-words group-hover/menu-item:tw-text-white': true,
                    'tw-text-sm': !menuItem.isHeader,
                    'tw-text-xs': menuItem.isHeader,
                    [menuItem.titleExtraClasses || '']: menuItem.titleExtraClasses
                  })
                        }, _toDisplayString(menuItem.title), 3),
                        _createElementVNode("p", {
                          class: _normalizeClass({
                    'tw-break-words group-hover/menu-item:tw-text-white': true,
                    'tw-text-slate-500': true,
                    'tw-text-xs': menuItem.isHeader
                  })
                        }, _toDisplayString(menuItem?.subTitle), 3)
                      ])
                    ], 42, _hoisted_2)
                  ]))
                }), 128)),
                (_ctx.showNoItemsFound && _ctx.menuItems.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No items found"))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createVNode(_component_StudioTooltip, {
      show: _ctx.hoveredItemId !== null && _ctx.getHoveredMenuItem()?.disabled && !!_ctx.getHoveredMenuItem()?.disabledReason,
      text: _ctx.getHoveredMenuItem()?.disabledReason || '',
      targetElement: (_ctx.hoveredItemElement as Element) || undefined
    }, null, 8, ["show", "text", "targetElement"])
  ])), [
    [_directive_studio_click_outside, _ctx.closeMenu]
  ])
}